module.exports = __webpack_public_path__ + "static/media/stanley.1884493f.jpg";